/**
 * Parse the parallel comma-delimited `contactIds` / `contactNames` strings
 * returned by the influencers data-grid endpoint into an array of
 * `{ id, name }` objects.
 *
 * Backend contract: `contactIds` and `contactNames` are independent
 * comma-delimited strings whose entries line up by index. They are NOT an
 * `id=Name` paired format.
 *
 *   contactIds:   "12,47,89"
 *   contactNames: "Ada Lovelace,Alan Turing,Grace Hopper"
 *
 * If the arrays are different lengths (unexpected), logs a warning and
 * falls back to names-only (ids returned as null).
 *
 * @param {string|null|undefined} contactIds
 * @param {string|null|undefined} contactNames
 * @returns {Array<{ id: number|null, name: string }>}
 */
export default function parseInfluencerContacts(contactIds, contactNames) {
  const names = contactNames ? contactNames.split(',') : [];
  if (names.length === 0) return [];

  const ids = contactIds ? contactIds.split(',') : [];

  if (ids.length !== names.length) {
    // eslint-disable-next-line no-console
    console.warn(
      '[influencers] contactIds / contactNames length mismatch; '
      + `ids=${ids.length} names=${names.length}. Falling back to names-only.`,
    );
    return names.map((name) => ({ id: null, name }));
  }

  return names.map((name, i) => ({
    id: parseInt(ids[i], 10),
    name,
  }));
}
